import React from 'react';
import { useNavigate } from "react-router-dom";
import { useAuthStore } from '../store/authStore';
import { logoutApi } from './AuthService';

const Unauthorized = () => {
  const navigate = useNavigate();
  const roles = useAuthStore(state => state.roles);
  const userRoles = Array.isArray(roles) ? roles : [];
  const hasNoPermissions = userRoles.length === 0 || userRoles.includes('NO_PERMISSIONS');

  const handleLogoutAndReturnToLogin = async () => {
    const accessToken = useAuthStore.getState().getToken();
    const refreshToken = useAuthStore.getState().getRefreshToken();
    await logoutApi(accessToken, refreshToken).catch(() => {});

    useAuthStore.getState().logout();
    sessionStorage.clear();
    localStorage.removeItem('pelikan-auth');
    localStorage.removeItem('pelikan-last-activity');
    localStorage.removeItem('pelikan-refresh-lock');

    navigate('/SignIn', { replace: true });
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      padding: '24px',
      boxSizing: 'border-box',
    }}>
      <div style={{
        background: 'rgba(30, 41, 59, 0.7)',
        backdropFilter: 'blur(16px)',
        border: '1px solid rgba(255, 255, 255, 0.08)',
        borderRadius: '24px',
        padding: '48px 32px',
        maxWidth: '480px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
      }}>
        {/* Icon with shield / lock */}
        <div style={{
          fontSize: '72px',
          marginBottom: '24px',
          animation: 'shake 1.5s ease-in-out infinite alternate',
        }}>
          🚫
        </div>

        <h1 style={{
          fontSize: '32px',
          fontWeight: 800,
          margin: '0 0 12px 0',
          background: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          letterSpacing: '-1px',
        }}>
          Brak autoryzacji
        </h1>

        <p style={{
          color: '#94A3B8',
          fontSize: '15px',
          lineHeight: '1.6',
          margin: '0 0 32px 0',
        }}>
          {hasNoPermissions
            ? 'Twoje konto nie posiada przypisanych uprawnień do korzystania z systemu. Skontaktuj się z administratorem lub wróć do ekranu logowania.'
            : 'Nie masz wystarczających uprawnień, aby przeglądać tę stronę. Skontaktuj się z administratorem lub wróć na poprzednią stronę.'}
        </p>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}>
          {!hasNoPermissions && (
            <>
              <button
                onClick={() => navigate(-1)}
                style={{
                  padding: '14px 28px',
                  borderRadius: '12px',
                  border: 'none',
                  background: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
                  color: '#FFFFFF',
                  fontWeight: 600,
                  fontSize: '15px',
                  cursor: 'pointer',
                  boxShadow: '0 4px 14px rgba(239, 68, 68, 0.3)',
                  transition: 'all 0.2s ease',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(239, 68, 68, 0.5)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = '0 4px 14px rgba(239, 68, 68, 0.3)';
                }}
              >
                Wróć na poprzednią stronę
              </button>

              <button
                onClick={() => navigate('/')}
                style={{
                  padding: '14px 28px',
                  borderRadius: '12px',
                  border: '1px solid rgba(255, 255, 255, 0.15)',
                  backgroundColor: 'transparent',
                  color: '#E2E8F0',
                  fontWeight: 600,
                  fontSize: '15px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.25)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)';
                }}
              >
                Strona główna
              </button>
            </>
          )}

          <button
            onClick={handleLogoutAndReturnToLogin}
            style={{
              padding: '14px 28px',
              borderRadius: '12px',
              border: hasNoPermissions ? 'none' : '1px solid rgba(255, 255, 255, 0.15)',
              background: hasNoPermissions
                ? 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)'
                : 'transparent',
              color: hasNoPermissions ? '#FFFFFF' : '#94A3B8',
              fontWeight: 600,
              fontSize: '15px',
              cursor: 'pointer',
              boxShadow: hasNoPermissions ? '0 4px 14px rgba(239, 68, 68, 0.3)' : 'none',
              transition: 'all 0.2s ease',
            }}
          >
            Wróć do ekranu logowania
          </button>
        </div>
      </div>
      
      <style>{`
        @keyframes shake {
          0% { transform: rotate(-5deg); }
          100% { transform: rotate(5deg); }
        }
      `}</style>
    </div>
  );
};

export default Unauthorized;
